import { FETCH_POSTS, FETCH_POST } from '../actions/posts';

const postsReducer = (state = [], action) => {
  switch (action.type) {
  	case FETCH_POST:
		return {...state, post: action.payload.data };
	case FETCH_POSTS:
	    return {...state, all: action.payload.data};
	default:
	    return state;
  }
};

export default postsReducer;



// WEBPACK FOOTER //
// ./src/reducers/posts.js